import React, { useState } from "react";
import { connect } from "react-redux";
import { useMountEffect } from "../../../hooks/LifeCycle";
import CustomCarousel from "../../../components/CustomCarousel/CustomCarousel";
import Spinner from "../../../components/Common/Spinner";
import { useHistory } from "react-router-dom";
import ConfiguracionActions from "../../../stores/configuracion/Actions";
import {
  DashboardStyles,
  DashboardButtonsContainer,
  ModalOptionsButtonsContainer,
  HospMenuWrapper,
  EgresosModalContainer,
  EgresosModalTitle,
  EgresosModalText,
} from "../styles/DashboardStyles";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import CustomModal from "../../../components/CustomModal/CustomModal";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomButton from "../../../components/CustomButton/CustomButton";
import TittleLine from "../../../components/Common/TittleLine";
import useEmpresa from "../../../hooks/useEmpresa";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import DashboardDisclaimer from "../components/DashboardDisclaimer";
import AutorizacionDiagnostico from "../../autorizacion/components/AutorizacionDiagnostico";
import CheckRender from "../../../components/Common/CheckRender";
import { getStandVirtualFullUrl } from "../../autorizacion/utils/AutorizacionUtils";
import { EMPRESA, PROGRAMA, PSS_TYPE } from "../../../utils/Constant";

const DashboardScreen = (props) => {
  const {
    prestador,
    isStandVirtual,
    tokenStandVirtual,
    configuracionPaperFree,
  } = props?.authUserData;

  const history = useHistory();
  const empresa = useEmpresa();
  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;
  const isPssNoMedico = prestador?.tipoPss === PSS_TYPE.NO_MEDICO;

  const [showModalPrecertificacion, setShowModalPrecertificacion] =
    useState(false);
  const [showModalHospitalizacion, setShowModalHospitalizacion] =
    useState(false);
  const [showModalEgresos, setShowModalEgresos] = useState(false);
  const [showModalValidacionHojas, setShowModalValidacionHojas] = useState(false);

  const showSolicitarAutorizacion =
    props?.consultarCargaPantallasData?.acceso?.moduloAutorizaciones;

  const showSolicitarMedicamentos =
    prestador?.tipo === "FARMACIA" &&
    props?.consultarCargaPantallasData?.acceso?.moduloMedicamento;

  const showBusquedaAvanzada =
    props?.consultarCargaPantallasData?.acceso?.moduloBusquedaAvanzada;

  const showPrecertificaciones =
    props?.consultarCargaPantallasData?.acceso?.moduloPrecertificaciones;

  const showHospitalizacion =
    isPssNoMedico &&
    props?.consultarCargaPantallasData?.acceso?.moduloHospitalizacion;
    
    console.log("showHospitalizacion", showHospitalizacion);
    console.log("isPssNoMedico", isPssNoMedico);
    console.log("props?.consultarCargaPantallasData?", props?.consultarCargaPantallasData);

  const showPromocionPrevencion = prestador?.pyp && isPrimera;

  const showLoading =
    props.consultarCargaPantallasLoading ||
    props.getAutorizacionesDiagnosticoLoading;

  useMountEffect(() => {
    props.consultarCargaPantallas();
  });

  const goTo = (screen) => {
    history.push(screen);
  };

  const goToStandVirtual = () => {
    const newTab = window.open(
      getStandVirtualFullUrl(tokenStandVirtual),
      "_blank"
    );
    newTab.focus();
  };

  return (
    <CustomLayout testid="dashboard-layout">
      <CustomSeparator height={"20px"} testid="separator-1" />

      <Section testid="welcome-section">
        <DashboardDisclaimer
          title={`¡Hola ${prestador?.nombre}!`}
          text={
            "Realiza las consultas y solicitudes de las autorizaciones en línea."
          }
          testid="welcome-disclaimer"
        />
      </Section>

      <CustomSeparator height={"30px"} testid="separator-2" />

      <Section testid="title-section">
        <TittleLine
          title={"Autorizaciones en línea"}
          weight={"bold"}
          testid="title-line"
        />
      </Section>

      <Section testid="buttons-section">
        <DashboardButtonsContainer testid="buttons-container">
          <CheckRender allowed={showSolicitarAutorizacion}>
            <CustomButton
              label={"Solicitar Autorización"}
              width={DashboardStyles.homeButtonWidth}
              weight={"bold"}
              onClick={() => {
                goTo("/autorizacion");
              }}
              testid="btn-solicitar-autorizacion"
            />
          </CheckRender>

          <CheckRender allowed={showSolicitarMedicamentos}>
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Solicitar Medicamentos"}
              width={DashboardStyles.homeButtonWidth}
              weight={"bold"}
              onClick={() => goTo("/medicamentos")}
            />
          </CheckRender>

          <CheckRender allowed={showBusquedaAvanzada}>
            <CustomSeparator width={"10px"} testid="separator-btn-1" />
            <CustomButton
              label={"Búsqueda Avanzada"}
              width={DashboardStyles.homeButtonWidth}
              weight={"bold"}
              onClick={() => {
                goTo("/busqueda-autorizacion");
              }}
              testid="btn-busqueda-avanzada"
            />
          </CheckRender>

          <CheckRender allowed={showPrecertificaciones}>
            <CustomSeparator width={"10px"} testid="separator-btn-2" />
            <CustomButton
              label={"Precertificaciones"}
              width={DashboardStyles.homeButtonWidth}
              weight={"bold"}
              onClick={() => {
                setShowModalPrecertificacion(true);
              }}
              testid="btn-precertificaciones"
            />
          </CheckRender>
          <CheckRender allowed={showHospitalizacion}>
            <CustomSeparator width={"10px"} testid="separator-btn-3" />
            <CustomButton
              label={"Hospitalización"}
              isLoading={false}
              width={DashboardStyles.homeButtonWidth}
              height={"auto"}
              weight={"bold"}
              onClick={() => {
                setShowModalHospitalizacion(true);
              }}
              testid="btn-hospitalizacion"
            />
          </CheckRender>

          <CustomSeparator width={"10px"} />

          <CheckRender allowed={isStandVirtual}>
            <CustomSeparator width={"10px"} testid="separator-btn-4" />
            <CustomButton
              label={"Stand Virtual"}
              width={DashboardStyles.homeButtonWidth}
              weight={"bold"}
              onClick={goToStandVirtual}
              testid="btn-stand-virtual"
            />
          </CheckRender>

          <CheckRender allowed={showPromocionPrevencion}>
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={PROGRAMA.PROMOCION_PREVENCION.DESCRIPCION}
              width={DashboardStyles.homeButtonWidth}
              weight={"bold"}
              onClick={() =>
                (window.location.href =
                  "/autorizacion?program=" +
                  PROGRAMA.PROMOCION_PREVENCION.CODIGO)
              }
              testid="btn-promocion-prevencion"
            />
          </CheckRender>
        </DashboardButtonsContainer>
      </Section>

      <CustomSeparator height={"50px"} testid="separator-3" />

      <CheckRender allowed={showLoading}>
        <Section align="center" flexDirection="column">
          <Spinner size={50} colorBorderTop={empresa?.COLOR_PRINCIPAL} />
        </Section>
      </CheckRender>

      <CheckRender allowed={configuracionPaperFree?.esPaperFree}>
        <Section testid="paperfree-section">
          <AutorizacionDiagnostico testid="autorizacion-diagnostico" />
        </Section>
      </CheckRender>

      <CustomSeparator height={"50px"} testid="separator-4" />

      <Section testid="carousel-section">
        <CustomCarousel images={empresa?.CAROUSEL} testid="carousel" />
      </Section>

      <CustomModal
        isOpen={showModalPrecertificacion}
        onClose={() => {
          setShowModalPrecertificacion(false);
        }}
        testid="modal-precertificacion"
      >
        <ModalOptionsButtonsContainer testid="modal-buttons-container">
          <CustomButton
            label={"Confirmar Precertificación"}
            width={DashboardStyles.homeButtonWidth}
            weight={"bold"}
            onClick={() => {
              goTo("/confirmar-precertificacion");
            }}
            testid="btn-confirmar-precertificacion"
          />
          <CustomSeparator width={"10px"} testid="modal-separator" />
          <CustomButton
            label={"Cancelar Precertificación"}
            width={DashboardStyles.homeButtonWidth}
            weight={"bold"}
            onClick={() => {
              goTo("/cancelar-precertificacion");
            }}
            testid="btn-cancelar-precertificacion"
          />
        </ModalOptionsButtonsContainer>
      </CustomModal>

      <CustomModal
        isOpen={showModalHospitalizacion}
        onClose={() => setShowModalHospitalizacion(false)}
        width="420px"
        maxWidth="95vw"
      >
        <EgresosModalContainer>
          <EgresosModalTitle>Hospitalización</EgresosModalTitle>
          <EgresosModalText>
            Seleccione la opción que desea realizar.
          </EgresosModalText>

          <CustomButton
            label={"Egresos"}
            width={"100%"}
            weight={"bold"}
            onClick={() => {
              setShowModalHospitalizacion(false);
              setShowModalEgresos(true);
            }}
          />

          <CustomSeparator height={"10px"} />

          <CustomButton
            label={"Validación Hojas Quirúrgicas"}
            width={"100%"}
            weight={"bold"}
            variant="outlined"
            onClick={() => {
              setShowModalHospitalizacion(false);
              setShowModalValidacionHojas(true);
            }}
          />
        </EgresosModalContainer>
      </CustomModal>

      <CustomModal
        isOpen={showModalEgresos}
        onClose={() => setShowModalEgresos(false)}
        width="420px"
        maxWidth="95vw"
      >
        <EgresosModalContainer>
          <EgresosModalTitle>Opciones de Egresos</EgresosModalTitle>
          <EgresosModalText>
            Seleccione la acción que desea realizar.
          </EgresosModalText>

          <CustomButton
            label={"Cierre Cuenta Clínica"}
            width={"100%"}
            weight={"bold"}
            onClick={() => {
              setShowModalEgresos(false);
              goTo("/cierre-cuenta-clinica");
            }}
          />

          <CustomSeparator height={"10px"} />

          <CustomButton
            label={"Búsqueda Avanzada"}
            width={"100%"}
            weight={"bold"}
            variant="outlined"
            onClick={() => {
              setShowModalEgresos(false);
              goTo("/busqueda-avanzada-egresos");
            }}
          />
        </EgresosModalContainer>
        </CustomModal>

      <CustomModal
        isOpen={showModalValidacionHojas}
        onClose={() => {
          setShowModalValidacionHojas(false);
        }}
        testid="modal-validacion-hojas"
        maxWidth="500px"
      >
        <Section flexDirection="column" style={{ alignItems: "center", padding: "20px" }}>
          <ModalOptionsButtonsContainer 
            testid="modal-validacion-hojas-buttons-container"
            style={{ flexDirection: "column", gap: "15px", width: "100%" }}
          >
            <CustomButton
              label={"Pacientes ingresados"}
              isLoading={false}
              width="100%"
              weight={"bold"}
              onClick={() => {
                setShowModalValidacionHojas(false);
                goTo("/pacientes-ingresados");
              }}
              testid="btn-pacientes-ingresados"
            />
            <CustomButton
              label={"Validaciones de hojas QX"}
              isLoading={false}
              width="100%"
              weight={"bold"}
              onClick={() => {
                setShowModalValidacionHojas(false);
                goTo("/validaciones-hoja-qx");
              }}
              testid="btn-validaciones-hoja-qx"
            />
          </ModalOptionsButtonsContainer>
        </Section>
      </CustomModal>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  getAutorizacionesDiagnosticoLoading:
    state.autorizacion.getAutorizacionesDiagnosticoLoading,
  consultarCargaPantallasData: state.configuracion.consultarCargaPantallasData,
  consultarCargaPantallasLoading:
    state.configuracion.consultarCargaPantallasLoading,
  consultarTipoPssNoMedicoData: state.prestador.consultarTipoPssNoMedicoData,
});

const mapDispatchToProps = {
  consultarCargaPantallas: ConfiguracionActions.consultarCargaPantallas,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardScreen);
